export const styles = {
    container: "relative",
    button: "flex items-center text-gray-700 dark:text-gray-400",
    initialsCircle: "mr-3 overflow-hidden w-12 h-12 flex items-center justify-center title-sm font-bold text-white bg-blue-500 rounded-full",
    userInfoContainer: "flex flex-col items-start mr-1",
    userName: "font-medium text-theme-sm",
    userEmail: "text-sm text-gray-500 dark:text-gray-400",
    chevronUp: "h-5 w-5 text-gray-800 dark:text-gray-400",
    chevronDown: "h-5 w-5 text-gray-800 dark:text-gray-400",
    dropdown: "absolute right-0 mt-[17px] w-[260px] rounded-2xl border border-gray-200 bg-white p-4 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark",
    dropdownHeader: "pb-3 border-b border-gray-200 dark:border-gray-800",
    dropdownName: "block font-semibold text-gray-800 dark:text-white",
    dropdownEmail: "text-sm text-gray-500 dark:text-gray-400",
    dropdownList: "flex flex-col gap-1 pt-4 pb-3",
    dropdownItem: "flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300",
    icon: "w-6 h-6 text-gray-500 flex-shrink-0",
    itemText: "pl-[2px]",
    // divider: "border-b border-gray-200 dark:border-gray-800 pt-0.3"
  };